"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewInvoiceRequest extends new_item_1.default {
    constructor(newInvoiceRequest) {
        super();
        this.assetIds = newInvoiceRequest.assetIds;
        this.vat = newInvoiceRequest.vat;
        this.memo = newInvoiceRequest.memo;
        this.dueDate = newInvoiceRequest.dueDate;
        this.pdfPer = newInvoiceRequest.pdfPer;
        this.startDate = newInvoiceRequest.startDate;
        this.endDate = newInvoiceRequest.endDate;
        this.status = newInvoiceRequest.status;
        this.size = newInvoiceRequest.size;
        this.customerEmail = newInvoiceRequest.customerEmail;
        this.customerName = newInvoiceRequest.customerName;
        this.includeBranding = newInvoiceRequest.includeBranding;
        this.invoiceNo = newInvoiceRequest.invoiceNo;
        this.vatId = newInvoiceRequest.vatId;
        this.issuingOrgEmail = newInvoiceRequest.issuingOrgEmail;
        this.issuingOrgName = newInvoiceRequest.issuingOrgName;
        this.issuingOrgPhoneNumber = newInvoiceRequest.issuingOrgPhoneNumber;
    }
}
exports.default = NewInvoiceRequest;
//# sourceMappingURL=new-invoiceRequest.js.map